import { render, staticRenderFns } from "./ChatMonitor.vue?vue&type=template&id=239bc650"
import script from "./ChatMonitor.vue?vue&type=script&lang=js"
export * from "./ChatMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports